import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
//  cookie functions
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
// svg icons
import IMAGES from "../../assets/images";

import './login.scss'
import ApiLoad from '../../components/ApiLoad';
import { waiterService } from '../../services';
import { handleMachineVersion } from '../../helper/machine';
import Error401 from '../Error401/error401';
import { setCookie, getCookie, erase } from "../../helper/cookieFunction";


function Invoice() {
  const {token, loggedIn,stateUrlToken } = useSelector((state: RootState) => state.waiter);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const {
    freezScreenState,
    alertMessageState,
    setLoginState,
    branchState, setLogOut
  } = bindActionCreators(actionCreators, dispatch);
  const [isLoading, setIsLoading] = useState(true);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [errorMessage, setErrorMessage] = useState("error");
  var urlToken = searchParams.get("token") ;  ///token encrypt
  

  const handleToken = async () => {
    setIsLoading(true)
    const { browserName, browserVersion } = await handleMachineVersion()
    let body = {
      code: urlToken ? urlToken : stateUrlToken ,
      type: browserName,
      version: browserVersion
    }
    const response = await waiterService.checkAuth(body);
    if (response.status == 200) {
      if (response.data.success === true) {
        setLoginState(response.data.data.token,urlToken ? urlToken :stateUrlToken);
        branchState(response.data.data.branch)
        setCookie(`bookingAgent_url_token_${urlToken ? urlToken :stateUrlToken}`, `${urlToken ? urlToken :stateUrlToken}`, 365);
        navigate('/scan-qr-code')
        freezScreenState(false);
      } else {
        freezScreenState(false);
        alertMessageState({
          type: "error",
          show: true,
          message: response.data.message,
        });
      }

    } else {
      setErrorMessage(response.data.message)
      freezScreenState(false);
      setIsLoading(false)

    }
  }

  useEffect(() => {
    if (Boolean(getCookie(`bookingAgent_url_token_${urlToken ? urlToken :stateUrlToken}`))) {
      // setLoginState(token,urlToken ? urlToken :stateUrlToken);
      console.log("if")
      navigate('/scan-qr-code')
    } else {
      console.log("else")
      handleToken()
    }
  }, [])


  if (isLoading) {
    return (
      <ApiLoad load={isLoading} />
    )
  }
  return (
    <Error401 errorMessage={errorMessage} />
  )
}

export default withTranslation()(Invoice);